export const DEFAULT_VALIDATE_FAIL = 'Данные указаны неверно';
export const DEFAULT_SEPARATOR = ' ';
